import type { CsrIndicator, CsrPillar } from "src/api/client-api/csrStrategy/useGetAllStrategy";
import { defaultCsrPillarIconKey, getCsrPillarIconKey } from "src/utils/csrStrategyPillarIcons";
import {
    normalizeRichContentForWrite,
    type CsrIndicatorForm,
    type CsrPillarForm,
} from "../EditPillarForm/PillarForm.utils";

export const createEmptyLever = (rowIndex: number): CsrIndicatorForm => ({
    rowIndex,
    "@id": undefined,
    position: rowIndex,
    name: "",
    leverShortName: "",
    leverFullName: "",
    indicatorLabel: "",
    valueColor: null,
    richContent: null,
    unitCode: "",
    currentValue: "",
    shortTermTarget: "",
    longTermTarget: "",
});

export const indicatorToLeverForm = (indicator: CsrIndicator, rowIndex: number): CsrIndicatorForm => ({
    rowIndex,
    "@id": indicator["@id"],
    position: indicator.position,
    name: indicator.name,
    leverShortName: indicator.leverShortName || indicator.name,
    leverFullName: indicator.leverFullName ?? "",
    indicatorLabel: indicator.indicatorLabel || indicator.name,
    valueColor: indicator.valueColor ?? null,
    richContent: indicator.richContent ?? null,
    unitCode: indicator.unitCode,
    currentValue: indicator.currentValue,
    shortTermTarget: indicator.shortTermTarget,
    longTermTarget: indicator.longTermTarget,
});

export const leverFormToWrite = (indicator: CsrIndicatorForm) => {
    const { rowIndex: _rowIndex, ...indicatorToWrite } = indicator;
    return {
        ...indicatorToWrite,
        name: indicator.indicatorLabel?.trim() || indicator.name.trim(),
        leverShortName: indicator.leverShortName?.trim() ?? "",
        leverFullName: indicator.leverFullName?.trim() || null,
        indicatorLabel: indicator.indicatorLabel?.trim() ?? "",
        unitCode: indicator.unitCode.trim(),
        richContent: normalizeRichContentForWrite(indicator.richContent),
    };
};

export const pillarToForm = (pillar?: CsrPillar): CsrPillarForm => ({
    id: pillar?.id,
    position: pillar?.position,
    name: pillar?.name ?? "",
    themes: [],
    icon: pillar?.icon ? getCsrPillarIconKey(pillar.icon) : defaultCsrPillarIconKey,
    indicators:
        pillar?.indicators.map((indicator, rowIndex) => ({
            rowIndex,
            ...indicator,
            leverShortName: indicator.leverShortName || indicator.name,
            indicatorLabel: indicator.indicatorLabel || indicator.name,
        })) ?? [],
});

export const canSaveLever = (indicator: CsrIndicatorForm) =>
    Boolean(
        indicator.leverShortName?.trim() &&
        indicator.indicatorLabel?.trim() &&
        indicator.currentValue.trim() &&
        indicator.valueColor,
    );

export const canSavePillar = (pillar: CsrPillarForm) => Boolean(pillar.name.trim() && pillar.icon);
